import Dialog from '../Dialog';

export const OkDialog = ({ isOpen, title, message, icon, onClick, onClose, loading }) => {
  return (
    <Dialog
      isOpen={isOpen}
      title={title}
      message={message}
      secondaryText="OK"
      onSecondaryClick={onClick}
      onClose={onClose}
      icon={icon}
      loading={loading}
    />
  );
};
